export const PAGE_SIZE = 10;
export const DATE_TIME_FORMAT = 'DD/MM/YYYY';
